<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-pre`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.42053 2.27463C6.16086 2.01528 5.73874 2.01517 5.47913 2.27463L2.59436 5.1594C2.56358 5.19017 2.53662 5.22466 2.51233 5.26096C2.50047 5.27867 2.49203 5.29809 2.48206 5.31662C2.47177 5.33571 2.4602 5.35409 2.45178 5.37424C2.38372 5.53754 2.38392 5.72162 2.45178 5.88498C2.45961 5.90379 2.47064 5.9208 2.4801 5.93869C2.49062 5.9586 2.49965 5.97929 2.51233 5.99826C2.53673 6.03483 2.56339 6.06983 2.59436 6.1008L5.47913 8.98557C5.73882 9.24527 6.16083 9.24527 6.42053 8.98557C6.68009 8.72586 6.68018 8.30381 6.42053 8.04416L4.67053 6.29514H9.12268C10.8603 6.29537 12.2689 7.70396 12.2692 9.44162C12.2692 11.1795 10.8605 12.5889 9.12268 12.5891H7.99963C7.63238 12.5891 7.3346 12.8869 7.33459 13.2541C7.33465 13.6213 7.63241 13.9192 7.99963 13.9192H9.12268C11.595 13.9189 13.5992 11.914 13.5992 9.44162C13.599 6.96942 11.5949 4.9653 9.12268 4.96506H4.67053L6.42053 3.21506C6.67989 2.95549 6.67974 2.5343 6.42053 2.27463Z"/></svg>
</template>
<script>

export default {
  name: 'IconLinePre',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
